export function createSerializationStats() {
    return {
        cssText: {
            count: 0,
            max: 0,
            sum: 0,
        },
        serializationDuration: {
            count: 0,
            max: 0,
            sum: 0,
        },
    };
}
export function updateSerializationStats(stats, metric, value) {
    stats[metric].count += 1;
    stats[metric].max = Math.max(stats[metric].max, value);
    stats[metric].sum += value;
}
export function aggregateSerializationStats(aggregateStats, stats) {
    for (const metric of ['cssText', 'serializationDuration']) {
        aggregateStats[metric].count += stats[metric].count;
        aggregateStats[metric].max = Math.max(aggregateStats[metric].max, stats[metric].max);
        aggregateStats[metric].sum += stats[metric].sum;
    }
}
//# sourceMappingURL=serializationStats.js.map